// Where the admin site lives, so the pairing screen can point a phone at it.
// Set for real deployments in .env.production; the fallback is the local dev
// server, so pairing by QR works with no configuration.
export const ADMIN_URL = (import.meta.env.VITE_ADMIN_URL || 'http://localhost:3001').replace(/\/$/, '');

// The admin site reads this parameter and claims the code automatically, so
// scanning the QR is the whole pairing flow rather than the start of it.
export const pairingURL = (code) => `${ADMIN_URL}/?pair=${encodeURIComponent(code)}`;
